export default __webpack_public_path__ + "static/media/backgroundHome.fac2d3f2.jpg";